import React from 'react';
import { Chip } from '@mui/material';
import { Wifi, WifiOff } from 'react-feather';
import { LicenseStatus, getLicenseStatusLabel, licenseStatusValueGetter } from '../../utils/licenseStatus';
import {
    formatLicenseActivationDate,
    formatLicenseDuration,
    formatLicenseExpirationDate,
    getLicenseActivationSortComparator,
    licenseActivationValueGetter,
    licenseDurationValueGetter,
} from '../../utils/licenseDuration';

export const licenseTableInitialState = {
    sorting: {
        sortModel: [
            { field: 'licenseCreated', sort: 'desc' },
        ],
    },
};

const colorMap = {
    [LicenseStatus.Activated]: 'success',
    [LicenseStatus.NotActivated]: 'secondary',
    [LicenseStatus.Expired]: 'warning',
    [LicenseStatus.Revoked]: 'error',
};

export function renderLicenseStatusChip(row) {
    const label = getLicenseStatusLabel(row);
    const color = colorMap[label];
    if (!color) {
        return null;
    }

    const icon = label === LicenseStatus.Activated ? <Wifi /> : <WifiOff />;

    return (
        <Chip
            icon={icon}
            variant="contained"
            color={color}
            label={label}
        />
    );
}

export function createLicenseStatusColumn({ width = 150 } = {}) {
    return {
        field: 'used',
        headerName: 'Status',
        width,
        headerClassName: 'header',
        sortable: true,
        filterable: true,
        type: 'singleSelect',
        valueOptions: [
            LicenseStatus.Revoked,
            LicenseStatus.Expired,
            LicenseStatus.Activated,
            LicenseStatus.NotActivated,
        ],
        valueGetter: licenseStatusValueGetter,
        renderCell: (cellValues) => renderLicenseStatusChip(cellValues.row),
    };
}

export function createLicenseActivationColumn({ width = 125 } = {}) {
    return {
        field: 'licenseActivation',
        headerName: 'Activated Date',
        width,
        headerClassName: 'header',
        valueGetter: licenseActivationValueGetter,
        getSortComparator: getLicenseActivationSortComparator,
        renderCell: (params) => formatLicenseActivationDate(params.row),
    };
}

export function createLicenseExpirationColumn({ width = 125 } = {}) {
    return {
        field: 'licenseExpiration',
        headerName: 'Expiration Date',
        width,
        headerClassName: 'header',
        renderCell: (params) => formatLicenseExpirationDate(params.row),
    };
}

export function createLicenseDurationColumn({ width = 125 } = {}) {
    return {
        // Field name kept for existing DataGrid sort fixtures; value comes from dates.
        field: 'licenseDayUsed',
        headerName: 'Duration',
        width,
        headerClassName: 'header',
        valueGetter: licenseDurationValueGetter,
        renderCell: (cellValues) => formatLicenseDuration(cellValues.row),
    };
}
